// extracted by mini-css-extract-plugin
module.exports = {"giftIdea":"GiftIdea_giftIdea__i1y3h"};